// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"515dde10","598":"33e66f7d","703":"3042b9d8"}[chunkId] + ".chunk.js";
};